type DatedExperiment = {
	id: string;
	date: string;
};

function byDateAsc(a: DatedExperiment, b: DatedExperiment) {
	if (a.date !== b.date) return a.date < b.date ? -1 : 1;
	return a.id.localeCompare(b.id);
}

export function getExperiments<T extends DatedExperiment>(list: T[]): T[] {
	return [...list].sort((a, b) => -byDateAsc(a, b));
}

/** 01 is the oldest experiment; numbers stay stable as new ones land. */
export function experimentNumberByDate<T extends DatedExperiment>(
	list: T[],
	id: string,
) {
	const index = [...list].sort(byDateAsc).findIndex((item) => item.id === id);
	return index >= 0 ? index + 1 : 0;
}
